import { Container, If, TipsBar, FormSoftlead } from '@/components'
import styles from './styles.module.scss'
import Image from 'next/image'
import playLogoUrl from '/public/images/foguete-play-logo.webp'
import heroBannerUrl from '/public/images/hero/jade.webp'

const Hero = ({ tipsBar = true }) => {
  return (
    <section className={styles.hero}>
      {tipsBar && (
        <TipsBar text={'TREINOS AO VIVO E GRAVADOS • EXPERIMENTE POR 7 DIAS'} />
      )}
      <div className={styles.background}>
        <div className={styles.content}>
          <Container classname={styles.container}>
            <div className={styles.content}>
              <p className={styles.title}>TREINE COM</p>
              <Image
                src={playLogoUrl}
                alt="Logo"
                width={196}
                height={86}
                priority={true}
                className={styles.logo}
              />
              <h1 className={styles.subtitle}>
                Resultados <span>rápidos, sem sair de casa</span>, em qualquer
                horário
              </h1>
            </div>

            <div className={styles.image}>
              <Image
                src={heroBannerUrl}
                width={300}
                height={225}
                priority={true}
                alt={'Treine com a Jade Picon'}
              />
            </div>

            <div>
              <FormSoftlead productId={'live'} />
            </div>
          </Container>
        </div>
      </div>
    </section>
  )
}

export default Hero
